import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const northRedingtonBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'North Redington Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in North Redington Beach, FL. Sam\'s Tree Service handles dangerous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_north_redington_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving North Redington Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in North Redington Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide the expert coastal tree care 
     that homeowners in <strong>North Redington Beach</strong> need. The direct Gulf 
     exposure here means trees face year round stress from salt, wind, and tropical 
     weather and when a storm hits, the damage to overgrown or weakened trees can 
     be immediate and severe. Our crew handles the tough cleanup and preventive 
     trimming that keeps your property safe before and after storms.`,

    `We specialize in <strong>hazardous tree removal and coastal trimming</strong> 
     addressing wind loaded canopies, salt compromised trunks, palms threatening 
     rooftops or neighboring properties, and large storm split limbs that need 
     careful rigging and removal on tight beachside lots. We work efficiently 
     and clean up completely.`,

    `<strong>Sam's Tree Service</strong> offers dependable, professional tree care 
     throughout <strong>North Redington Beach</strong> and the entire 
     <strong>Pinellas barrier island</strong> chain so your Gulf front property 
     stays safe and beautiful through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'North Redington Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_NorthRedingtonBeach = () => <LocationPage config={northRedingtonBeachConfig} />;
export default Services_NorthRedingtonBeach;
